function forgotEventHandlers() {

    $("#login-email").on("input", function() {
       
       $("#login-forgot-messages").hide();
       $("#login-forgot-messages").empty();

    });

    $('#init-forgot-password').click(function(e) {

        e.preventDefault();
        
        var btn = $(this);
        var form = $(this).closest('form');

        form.validate({
            rules: {
                loginemail: {
                    required: true,
                    email: true
                }
            }
        });

        if (!form.valid()) {
            return;
        }

        form.serialize();

        btn.addClass('spinner spinner--right spinner--sm spinner--light').attr('disabled', true);

        form.ajaxSubmit({
            url: 'https://'+document.location.hostname+'/api/v2/Auth/InitLoginForgot.php',
            type: 'post',
            success: function(response, status, xhr, $form) {
                
                var obj = $.parseJSON(response);
                var stat = obj.status;
                var write = obj.write;

                if (stat == 200) {

                    var email = obj.email;

                    setTimeout(function() { 
                        
                        btn.removeClass('spinner spinner--right spinner--sm spinner--light').attr('disabled', false);

                        $("#login-rest-form").empty();
                        $("#login-rest-form").hide();
                        $("#login-forgot-messages").show();
                        $("#login-forgot-messages").html('<div class="success-message"><div class="row"><div class="col-auto"><i class="fas fa-check-circle"></i></div><div class="col"><span>A password reset link has been sent to ' +email+ '.</span></div></div></div>');
                        

                    }, 2000);

                } else {

                    btn.removeClass('spinner spinner--right spinner--sm spinner--light').attr('disabled', false);

                    $("#login-forgot-messages").show();
                    $("#login-forgot-messages").html('<div class="error-message"><div class="row"><div class="col-auto"><i class="fas fa-info-circle"></i></div><div class="col"><span>We couldn\'t find an account with that email address</span></div></div></div>');
                    

                }
            },
        });

    }); 
}


jQuery(document).ready(function() {

    forgotEventHandlers();

});
